<style lang="scss">
@import './styles/index.scss';
@import './App.scss';
.is-iframe {
  padding-top: 64px;
  height: 100%;
}

.is-iframe.demo {
  padding-top: 128px;
}

.is-dash {
  margin-left: 0;
}

.chart-full {
  width: 100%;
  height: 100%;
}

.gray-back {
  background-color: #f7f8f8;
}
</style>
<template>
  <div class="app" id="app">
    <div class="demotip" v-if="$demo">
      <span v-if="tokenid === 'demo'">{{ $t('demo.info1') }}</span>
      <span v-else>{{ $t('demo.info2') }}</span>
      <i-button class="ivu-btn-ghost" v-if="tokenid === 'demo'" @click="goLogin" ghost-tmp shape="circle">{{ $t('demo.login') }}</i-button>
      <i-button class="ivu-btn-ghost" @click="goCreate" v-else ghost-tmp shape="circle">{{ $t('demo.link') }}</i-button>
    </div>
    <i-header style="position: relative"></i-header>
    <div style="display: flex" :style="{ height: calcHeight }">
      <div style="height: 100%; position: static" class="aaaaaa">
        <i-navigation v-show="showNav" style="height: 100%"></i-navigation>
      </div>
      <div class="chart-full" style="width: calc(100% - 200px)">
        <global-filter
          v-if="showFil && reloader && !filterSingle"
          :ownProduct="false"
          :showDate="haveFilter"
          :showCondition="haveFilter"
          v-on:gob-change-date="gobChangeDate"
          v-on:gob-change-product="gobChangeProduct"
          v-on:gob-change-platform="gobChangePlatform"
          v-on:gob-change-condition="gobChangeCondition"
          style="position: relative"
        ></global-filter>
        <select-app
          v-if="showFil && reloader && filterSingle"
          v-on:gob-change-product="gobChangeProduct"
          style="position: relative"
        ></select-app>
        <div v-if="showFil && !reloader" style="height: 56px"></div>
        <div style="overflow-y: auto; flex-grow: 1" :style="{ height: calcInnerHeight }">
          <router-view style="min-height: calc(100% - 52px)"></router-view>
          <i-footer
            v-show="showFooter && footerShow"
            :class="{ 'gray-back': conGrayBg }"
            style="padding: 0 24px"
            ref="footerRef"
          ></i-footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cookie from 'js-cookie';
import bus from './libs/bus';
import iHeader from './components/header/index';
import iNavigation from './components/navigation/index';
import SelectApp from './components/global-filter/SelectApp';
import GlobalFilter from './components/global-filter/GlobalFilter';
import iFooter from './components/footer/index';
import BaseReq from './base/BaseReq';
import StateHandler from './base/StateHandler';
import config from './config/filter-config';

export default {
  components: {
    iHeader,
    iNavigation,
    GlobalFilter,
    SelectApp,
    iFooter,
  },
  data() {
    return {
      tokenid: '',
      conGrayBg: false,
      padBotton: false,
      qualityGrayBg: false,
      createProductPage: false,
      userGroupModal: false, // 用户分群筛选提示框显示隐藏
      modalText: 'page',

      reloader: true,

      singleFilterMap: {
        'smart-new': true,
        subscription: true,
        subscriptionEdit: true,
        userPortrait: true,
      },

      footerShow: false,
      filterSingle: false,
    };
  },
  watch: {
    pathUrl() {
      this.footerType();
      this.buryPoint();
    },
    '$route.name': function (params) {
      this.filterSingle = this.singleFilterMap[params] !== undefined;

      if (this.showFil) {
        this.reloader = false;
        setTimeout(() => {
          this.reloader = true;
        });
      }
    },
  },
  computed: {
    calcInnerHeight() {
      if (this.showFil) {
        return 'calc(100% - 56px)';
      } else {
        return '100%';
      }
    },
    haveFilter() {
      const noFilter = config.noFilter;
      const path = this.$route.path;
      for (let i = 0, len = noFilter.length; i < len; i += 1) {
        if (path.indexOf(noFilter[i]) !== -1 && path.indexOf('funnelChart') === -1) {
          return false;
        }
      }
      return true;
    },
    calcHeight() {
      let retVal = 64;
      const path = this.$route.path;
      if (path.indexOf('productCenter') > -1 && path.indexOf('createProduct') === -1) {
        retVal += 46;
      }
      if (this.$demo) {
        retVal += 64;
      }
      return `calc(100% - ${retVal}px)`;
    },
    // 是否显示左部菜单
    showNav() {
      const pathTmp = this.$route.path.split('/')[1];
      return (
        !!this.$route.name &&
        pathTmp.indexOf('productCenter') === -1 &&
        pathTmp.indexOf('dashboard') === -1 &&
        pathTmp.indexOf('gameReport') === -1
      );
    },
    isDash() {
      if (!this.$route.name) return false;
      const routeName = this.$route.name;
      return routeName === 'dashboard';
    },
    // 是否显示头部filter
    showFil() {
      if (!this.$route.name) return false;
      const routePath = this.$route.path;
      const routeName = this.$route.name;
      const path = routePath.split('/')[1];
      return (
        routeName !== 'quality' &&
        routeName !== 'qualityDetail' &&
        routeName !== 'channelManage' &&
        path.indexOf('productCenter') === -1 &&
        path !== 'account' &&
        routePath.indexOf('user/mc') === -1 &&
        routePath.indexOf('exportLog') === -1
      );
    },
    pathUrl() {
      return this.$route.path;
    },
    showFooter() {
      if (!this.$route.name) return false;
      const routeName = this.$route.name;
      return routeName !== 'quality' && routeName !== 'qualityDetail' && routeName !== 'channelManage';
    },
  },
  mounted() {
    setTimeout(() => {
      this.footerShow = true;
    }, 1000);

    const self = this;
    self.$Message.config({
      duration: 3,
      top: 80,
    });

    // this.footerType();
    bus.getToken();
    this.tokenid = bus.token;
    this.buryPoint();

    // 增加iframe事件监听
    window.addEventListener('message', (event) => {
      const msgObj = event.data;

      if (typeof msgObj !== 'object') {
        return;
      }

      this.saveLocalStore(msgObj);

      if (msgObj.eventType && msgObj.eventType.startsWith('msg-goto-')) {
        const dirList = msgObj.eventType.split('-');
        this.$router.push({
          name: dirList[2],
          params: {
            productId: bus.productid,
          },
          query: msgObj.eventInfo || {},
        });
      } else if (msgObj.eventType === 'msg-change-product') {
        this.$store.commit('setProductObj', msgObj.eventInfo);
        setTimeout(() => {
          bus.changeProduct(msgObj.eventInfo);
        });
      } else if (msgObj.eventType === 'msg-change-platform') {
        bus.changePlatform(msgObj.eventInfo);
      } else if (msgObj.eventType === 'msg-change-condition') {
        bus.changeCondition(msgObj.eventInfo);
      } else if (msgObj.eventType === 'msg-change-date') {
        bus.changeDate(msgObj.eventInfo);
      } else if (msgObj.eventType === 'msg-change-lang') {
        const name = msgObj.eventInfo;
        if (this.$refs.footerRef) {
          this.$refs.footerRef.changeLanguage(name);
        }
      } else if (msgObj.eventType === 'msg-error-420') {
        this.$Modal.warning({
          title: '警告',
          content: `测试环境，请求发现错误：420`,
          okText: 'OK',
        });
      } else if (msgObj.eventType === 'msg-change-route') {
        document.getElementsByClassName('scrollbar')[0].scrollTop = msgObj.eventInfo.scrollTop;
        this.$router.push({
          path: msgObj.eventInfo.path,
          query: {
            _src: 'outside',
          },
        });
      } else if (msgObj.eventType === 'msg-edit-product') {
        BaseReq.getProductList();
      } else if (msgObj.eventType === 'msg-remove-product') {
        this.$store.commit('sliceProduct', msgObj.eventInfo);
      }
    });
  },
  methods: {
    // demo跳转登录
    goLogin() {
      const backurl = 'https://www.talkingdata.com/app?zh_cn&languagetype=zh_cn';
      window.location.href = `https://account.talkingdata.com/regist.jsp?cf=0&backurl=${backurl}`;
    },
    // demo跳转创建应用
    goCreate() {
      const token = cookie.get('_app_token_').replace('_demo', '');
      cookie.set('_app_token_', token, { expires: 7, path: '/' });
      cookie.set('newAppGuide', 'false', { domain: '.talkingdata.com' });
      window.location.href = `${window.location.origin}/app/newVersion`;
      // this.$router.go('/productCenter/createProduct');
      // window.location.reload(true);
    },
    // footer是否为灰色背景
    footerType() {
      const path = this.$route.path;
      this.conGrayBg = false;
      this.qualityGrayBg = false;
      this.createProductPage = false;
      this.padBotton = false;

      if (
        (path.indexOf('user/group') > -1 && path.indexOf('edit') > -1) ||
        (path.indexOf('funnel') > -1 && path.indexOf('setFunnel') > -1) ||
        (path.indexOf('manage') > -1 && path.indexOf('info') > -1) ||
        (path.indexOf('manage') > -1 && path.indexOf('openapi') > -1) ||
        (path.indexOf('account') > -1 && path.indexOf('edit') > -1)
      ) {
        this.conGrayBg = true;
        return 'normal';
      }
      return 'normal';
    },
    // 埋点统计
    buryPoint() {
      const tmp = this.$route.path.split(`/${this.$route.params.productid}`)[0];
      const subs = tmp.indexOf('?') === -1 ? tmp.split('/') : tmp.substring(0, tmp.indexOf('?')).split('/');
      let name = '';
      subs.forEach((item) => {
        if (name === '') {
          name += item;
        } else {
          name += item ? `_${item}` : '';
        }
      });
      const appName = name;
      if (appName) {
        // 打点统计
        window.TDAPP.onEvent(appName);
        localStorage['_app_prename'] = appName;
      }
    },
    saveLocalStore(msgObj) {
      if (msgObj.eventType === 'msg-change-product') {
        const pObj = msgObj.eventInfo;
        const tmpObj = {
          productid: '' + pObj.productid,
          productname: pObj.productname,
          registertime: pObj.registertime,
          authorized: pObj.authorized,
          watchshow: pObj.watchshow,
          platformFull: pObj.platform,
          platform: pObj.platform,
          conditions: {
            partner: [],
            usergroup: [],
            version: [],
            newUserGroup: [],
          },
        };
        StateHandler.savePublic(tmpObj);
      } else if (msgObj.eventType === 'msg-change-platform') {
        StateHandler.savePublic({ platform: msgObj.eventInfo });
      } else if (msgObj.eventType === 'msg-change-date') {
        StateHandler.savePublic({ selectedDate: msgObj.eventInfo });
      } else if (msgObj.eventType === 'msg-change-qulitydate') {
        StateHandler.savePublic({ qualitySelectedDate: msgObj.eventInfo });
      } else if (msgObj.eventType === 'msg-change-condition') {
        StateHandler.savePublic({ conditions: msgObj.eventInfo });
      } else if (msgObj.eventType === 'msg-change-lang') {
        StateHandler.savePublic({ lang: msgObj.eventInfo });
      }
    },

    gobChangeDate(paramObj) {
      bus.changeDate(paramObj);
    },
    gobChangeProduct(paramObj) {
      bus.changeProduct(paramObj);
    },
    gobChangePlatform(paramObj) {
      bus.changePlatform(paramObj);
    },
    gobChangeCondition(paramObj) {
      bus.changeCondition(paramObj);
    },
  },
};
</script>
